import { GetPhases } from '@/_services/jobs';

const TVQ = 0.09975;
const TPS = 0.05;
const TAXE = 1.14975;

const getTotalCostsFromPhases = phases => {
  let totalLaborCost = 0;
  let totalMaterialCost = 0;
  let totalSubcontractingCost = 0;
  for (let phase of phases) {
    totalMaterialCost += phase.totalMaterialCost;
    totalLaborCost += phase.totalLaborCost;
    totalSubcontractingCost += phase.totalSubcontractingPrice;
  }

  return {
    totalMaterialCost,
    totalLaborCost,
    totalSubcontractingCost,
  };
};

const getFraisFromGetPhases = rep => ({
  material: {
    admin: rep.materialAdmin,
    profit: rep.materialProfit,
    adjustment: rep.materialAdjustment,
  },
  labor: {
    admin: rep.laborAdmin,
    profit: rep.laborProfit,
    adjustment: rep.laborAdjustment,
  },
  subcontract: {
    admin: rep.subcontractAdmin,
    profit: rep.subcontractProfit,
    adjustment: rep.subcontractAdjustment,
  },
});

export const stepperMixin = {
  methods: {
    updateTotalCost: function (jobId) {
      return new Promise((resolve, reject) => {
        GetPhases(jobId)
          .then(rep => {
            this.$store.dispatch('submission/updateAllTotalCost', getTotalCostsFromPhases(rep.phases));
            this.$store.dispatch('submission/updateLocked', rep.locked);
            resolve();
          })
          .catch(err => reject(err));
      });
    },
    updateFrais: function (jobId) {
      return new Promise((resolve, reject) => {
        //can be optimize by using another endpoint, this one is slow
        GetPhases(jobId)
          .then(rep => {
            this.$store.dispatch('submission/updateFrais', getFraisFromGetPhases(rep));
            resolve();
          })
          .catch(err => reject(err));
      });
    },
  },
};

export const calculMixin = {
  methods: {
    parseInput(input) {
      if (!input || input === '') {
        return 0;
      }
      return parseFloat(input);
    },
    formatPercentage(perc) {
      if (!perc) {
        return 0.0;
      }
      return (Math.round(perc * 100) / 100).toFixed(2);
    },

    calculAdminAmount(subTotal, fee) {
      return (subTotal * fee) / 100;
    },
    calculProfitAmount(subTotal, adminFee, profitFee) {
      return (subTotal * (1 + adminFee / 100) * profitFee) / 100;
    },
    calculSum(elements) {
      return elements.reduce((acc, val) => acc + val, 0);
    },
    calcTvq(total) {
      return total * TVQ;
    },
    calcTps(total) {
      return total * TPS;
    },
    calcTotalWithTaxes(total) {
      return total * TAXE;
    },

    // Solve JS problem Math.Round(1.255 * 100) / 100 ==> 1.25
    // because 1.255 * 100 !== 125.5
    roundNumber(number, decimal) {
      const multiplier = Math.pow(10, decimal);
      return Math.round(Math.round(number * 10 * multiplier) / 10) / multiplier;
    },
  },
};

export const calculCostMixin = {
  data() {
    return {
      material: {
        admin: 0,
        profit: 0,
        adjustment: 0,
      },
      labor: {
        admin: 0,
        profit: 0,
        adjustment: 0,
      },
      subcontract: {
        admin: 0,
        profit: 0,
        adjustment: 0,
      },
    };
  },
  methods: {
    calcJobMaterialAdmin() {
      return this.calculAdminAmount(this.calcJobMaterialSubTotal(), this.material.admin);
    },
    calcJobMaterialAdminReport(material) {
      return this.calculAdminAmount(this.calcJobMaterialSubTotal(), material.admin);
    },
    calcJobMaterialProfit() {
      return this.calculProfitAmount(this.calcJobMaterialSubTotal(), this.material.admin, this.material.profit);
    },
    calcJobMaterialProfitReport(material) {
      return this.calculProfitAmount(this.calcJobMaterialSubTotal(), material.admin, material.profit);
    },

    calcJobLaborProfit() {
      return this.calculProfitAmount(this.calcJobLaborSubTotal(), this.labor.admin, this.labor.profit);
    },
    calcJobLaborProfitReport(labor) {
      return this.calculProfitAmount(this.calcJobLaborSubTotal(), labor.admin, labor.profit);
    },
    calcJobLaborAdmin() {
      return this.calculAdminAmount(this.calcJobLaborSubTotal(), this.labor.admin);
    },
    calcJobLaborAdminReport(labor) {
      return this.calculAdminAmount(this.calcJobLaborSubTotal(), labor.admin);
    },

    calcJobSubcontractProfit() {
      return this.calculProfitAmount(
        this.calcJobSubcontractSubTotal(),
        this.subcontract.admin,
        this.subcontract.profit,
      );
    },
    calcJobSubcontractProfitReport(subcontract) {
      return this.calculProfitAmount(this.calcJobSubcontractSubTotal(), subcontract.admin, subcontract.profit);
    },
    calcJobSubcontractAdmin() {
      return this.calculAdminAmount(this.calcJobSubcontractSubTotal(), this.subcontract.admin);
    },
    calcJobSubcontractAdminReport(subcontract) {
      return this.calculAdminAmount(this.calcJobSubcontractSubTotal(), subcontract.admin);
    },

    calcJobMaterialSubTotal() {
      return this.$store.getters['submission/getTotalMaterialCost'];
    },
    calcJobLaborSubTotal() {
      return this.$store.getters['submission/getTotalLaborCost'];
    },
    calcJobSubcontractSubTotal() {
      return this.$store.getters['submission/getTotalSubcontractingCost'];
    },

    calcJobSubTotalTotal() {
      return this.calculSum([
        this.calcJobMaterialSubTotal(),
        this.calcJobLaborSubTotal(),
        this.calcJobSubcontractSubTotal(),
      ]);
    },
    calcJobAdminTotal() {
      return this.calculSum([this.calcJobMaterialAdmin(), this.calcJobLaborAdmin(), this.calcJobSubcontractAdmin()]);
    },
    calcJobAdminTotalReport(material, labor, subcontract) {
      return this.calculSum([
        this.calcJobMaterialAdminReport(material),
        this.calcJobLaborAdminReport(labor),
        this.calcJobSubcontractAdminReport(subcontract),
      ]);
    },
    calcJobProfitTotal() {
      return this.calculSum([this.calcJobMaterialProfit(), this.calcJobLaborProfit(), this.calcJobSubcontractProfit()]);
    },
    calcJobProfitTotalReport(material, labor, subcontract) {
      return this.calculSum([
        this.calcJobMaterialProfitReport(material),
        this.calcJobLaborProfitReport(labor),
        this.calcJobSubcontractProfitReport(subcontract),
      ]);
    },
    calcJobAdjustmentTotal() {
      return this.calculSum([
        this.parseInput(this.material.adjustment),
        this.parseInput(this.labor.adjustment),
        this.parseInput(this.subcontract.adjustment),
      ]);
    },
    calcJobAdjustmentTotalReport(material, labor, subcontract) {
      return this.calculSum([
        this.parseInput(material.adjustment),
        this.parseInput(labor.adjustment),
        this.parseInput(subcontract.adjustment),
      ]);
    },

    calcJobTotal() {
      return this.calculSum([this.calcJobMaterialTotal(), this.calcJobLaborTotal(), this.calcJobSubcontractTotal()]);
    },
    calcJobMaterialTotal() {
      return this.calculSum([
        this.calcJobMaterialSubTotal(),
        this.calcJobMaterialAdmin(),
        this.calcJobMaterialProfit(),
        this.parseInput(this.material.adjustment),
      ]);
    },
    calcJobLaborTotal() {
      return this.calculSum([
        this.calcJobLaborSubTotal(),
        this.calcJobLaborAdmin(),
        this.calcJobLaborProfit(),
        this.parseInput(this.labor.adjustment),
      ]);
    },
    calcJobSubcontractTotal() {
      return this.calculSum([
        this.calcJobSubcontractSubTotal(),
        this.calcJobSubcontractAdmin(),
        this.calcJobSubcontractProfit(),
        this.parseInput(this.subcontract.adjustment),
      ]);
    },
  },
};
